module.exports = __webpack_public_path__ + "static/thaw-share-bg-a80d216c7cabb44558af55e59707e1db.png";